const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

export const VERTICAL_SORTABLE_SCROLL_AREA_CLASS =
  'vertical-sortable-scroll-area';

export const canScrollVerticalSortableArea = (element) =>
  Boolean(
    element?.classList?.contains?.(VERTICAL_SORTABLE_SCROLL_AREA_CLASS)
  );

export const restrictVerticalSortableMovement = ({
  transform,
  activeNodeRect,
  containerNodeRect,
}) => {
  const nextTransform = {
    ...transform,
    x: 0,
  };

  if (!activeNodeRect || !containerNodeRect) {
    return nextTransform;
  }

  const minY = containerNodeRect.top - activeNodeRect.top;
  const maxY = containerNodeRect.bottom - activeNodeRect.bottom;

  if (minY > maxY) {
    return nextTransform;
  }

  return {
    ...nextTransform,
    y: clamp(transform.y, minY, maxY),
  };
};

export const getSortableMoveIndexes = (itemIds, activeId, overId) => {
  if (overId === null || overId === undefined || activeId === overId) {
    return null;
  }

  const fromIndex = itemIds.indexOf(activeId);
  const toIndex = itemIds.indexOf(overId);

  if (fromIndex < 0 || toIndex < 0) return null;

  return { fromIndex, toIndex };
};
